module.exports = __webpack_public_path__ + "static/media/link_expire.00877653.gif";